// removed by extract-text-webpack-plugin
module.exports = {"root":"index-m-root-2yA0F"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modal/style/index.m.less
// module id = 1034
// module chunks = 0 1